import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { usePortfolio } from '../../context/PortfolioContext';

const Experience = () => {
  const { portfolioData } = usePortfolio();
  const experience = portfolioData?.experience || [];
  const [visibleCount, setVisibleCount] = useState(3);

  const toggleVisibility = () => {
    setVisibleCount(visibleCount === 3 ? experience.length : 3);
  };

  const visibleExperience = experience.filter(item => item.visible);

  if (!experience.length) {
    return (
      <div className="py-8">
        <h3 className="text-2xl font-semibold text-white mb-8 flex items-center gap-3">
          <FaBriefcase className="text-primary" />
          Work Experience
        </h3>
        <div className="text-gray-400">No experience data available. Please add entries in the admin dashboard.</div>
      </div>
    );
  }

  return (
    <div className="py-8">
      <h3 className="text-2xl font-semibold text-white mb-8 flex items-center gap-3">
        <FaBriefcase className="text-primary" />
        Work Experience
      </h3>
      <div className="space-y-6">
        {visibleExperience.slice(0, visibleCount).map((item, index) => (
          <motion.div 
            key={item.id || index}
            className="bg-secondary/30 p-6 rounded-lg border border-primary/10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="flex flex-col md:flex-row justify-between mb-3">
              <h4 className="text-xl font-medium text-white">{item.role}</h4>
              <span className="text-primary">{item.duration || item.period}</span>
            </div>
            <p className="text-gray-300 mb-3">
              {item.company}{item.location ? `, ${item.location}` : ''}
            </p>
            <p className="text-gray-400 mb-4">{item.summary || item.description}</p>
            <div className="flex flex-wrap gap-2 mb-2">
              {item.technologies && item.technologies.map((tech, techIndex) => (
                <span 
                  key={techIndex} 
                  className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm"
                >
                  {tech}
                </span>
              ))}
            </div>
            {item.achievements && item.achievements.length > 0 && (
              <ul className="list-disc list-inside text-gray-300 mb-2">
                {item.achievements.map((ach, aIdx) => (
                  <li key={aIdx}>{ach}</li>
                ))}
              </ul>
            )}
          </motion.div>
        ))}
      </div>
      {experience.length > 3 && (
        <div className="text-center mt-8">
          <button
            onClick={toggleVisibility}
            className="flex items-center gap-2 mx-auto px-4 py-2 bg-primary/10 text-primary rounded-full hover:bg-primary/20 transition-colors"
          >
            {visibleCount === 3 ? (
              <>
                See More <FaChevronDown />
              </>
            ) : (
              <>
                See Less <FaChevronUp />
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default Experience; 